<template>
  <div class="position-paper-section">
    <div class="subsection-header">
      <h6>Position Papers</h6>
      <button type="button" @click="$emit('addPositionPaper')" :disabled="isDisabled" :class="['add-sub-btn', { disabled: isDisabled }]">Add Position Paper</button>
    </div>
    <div v-for="(position, pidx) in positionPapers" :key="pidx" class="position-item">
      <div class="position-header">
        <span>Position Paper #{{ pidx + 1 }}</span>
        <button type="button" @click="$emit('deletePositionPaper', pidx)" :disabled="isDisabled" :class="['delete-sub-btn', { disabled: isDisabled }]">Delete</button>
      </div>
      <div class="form-grid">
        <div class="form-group">
          <label>Position Paper Title:</label>
          <InputText v-model="position.positiontitle" />
        </div>
        <div class="form-group">
          <label>Status:</label>
          <InputText v-model="position.status" />
        </div>
        <div class="form-group">
          <label>Date:</label>
          <DatePicker v-model="position.date" dateFormat="yy-mm-dd" />
        </div>
        <div class="form-group">
          <label>Source/Link:</label>
          <InputText v-model="position.source" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'PositionPaper',
  props: {
    positionPapers: {
      type: Array,
      default: () => []
    },
    statusOptions: {
      type: Array,
      default: () => []
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.position-paper-section {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.subsection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.subsection-header h6 {
  color: #6366f1;
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
}

.position-item {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.position-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 600;
  color: #6366f1;
  font-size: 0.9rem;
}

.form-group input,
.form-group textarea {
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.add-sub-btn {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.add-sub-btn:hover {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
}

.delete-sub-btn {
  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 0.8rem;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
}

.delete-sub-btn:hover {
  background: linear-gradient(135deg, #b91c1c 0%, #dc2626 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4);
}

.delete-sub-btn.disabled, .add-sub-btn.disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.delete-sub-btn.disabled:hover, .add-sub-btn.disabled:hover {
  background: #9ca3af;
  transform: none;
  box-shadow: none;
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .subsection-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .position-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}
</style>